import { reactive } from 'vue';
import { sessionClient } from '../api/sessionClient';

export const authState = reactive({
  email: null as string | null,
  secret: null as string | null,
  loading: true,
});

export async function bootstrapAuth(): Promise<boolean> {
  authState.loading = true;
  try {
    const me = await sessionClient.me();
    authState.email = me.email;
    authState.secret = me.secret;
    return true;
  } catch {
    authState.email = null;
    authState.secret = null;
    return false;
  } finally {
    authState.loading = false;
  }
}

export async function login(email: string, password: string): Promise<void> {
  await sessionClient.login(email, password);
  await bootstrapAuth();
}

export async function logout(): Promise<void> {
  await sessionClient.logout();
  authState.email = null;
  authState.secret = null;
}
